import LocalData from '../../helpers/local-data';
import Config from '../../config';

let property = LocalData.load(Config.LOCAL_DATA_IDS.PROPERTY);
let activeMenu = LocalData.load(Config.LOCAL_DATA_IDS.ACTIVE_MENU);
const parsedProperty = property ? JSON.parse(property) : null;
const emptyWyndhamReviewStatus = {
    percent: 0,
    pagesReviewed: 0,
    pagesRequired: 21,
    unreviewedPages: [],
    hasSignedOff: false,
    signedOffBy: null,
    signedOffAt: null,
};

const initialState = {
    property: parsedProperty,
    activeMenu: activeMenu ? activeMenu : null,
    sidebarShow: 'responsive',
    asideShow: false,
    darkMode: true,
    contentChanged: false,
    userHotels: [],
    hotelInfo: null,
    wyndhamReviewStarted: parsedProperty && parsedProperty.isWyndham === true,
    wyndhamChangedFields: [],
    wyndhamReviewStatus: {...emptyWyndhamReviewStatus},
    wyndhamReviewNoticeVisible: false,
    wyndhamReviewNoticeDismissedFor: null,
};

const Reducer = (state = initialState, action) => {
    switch (action.type) {
        case Config.REDUX_TYPES.PROPERTY_UPDATE: {
            const previousId = state.property && (state.property.id || state.property.guid);
            const nextId = action.payload && (action.payload.id || action.payload.guid);
            const propertyChanged = String(previousId || '') !== String(nextId || '');
            LocalData.save(Config.LOCAL_DATA_IDS.PROPERTY, JSON.stringify(action.payload));

            return {
                ...state,
                type: action.type,
                property: action.payload,
                ...(propertyChanged ? {
                    wyndhamChangedFields: [],
                    wyndhamReviewStarted: false,
                    wyndhamReviewStatus: {...emptyWyndhamReviewStatus},
                    wyndhamReviewNoticeVisible: false,
                } : {}),
            };
        }
        case Config.REDUX_TYPES.ACTIVE_MENU_UPDATE:
            LocalData.save(Config.LOCAL_DATA_IDS.ACTIVE_MENU, action.payload);

            return {
                ...state,
                ...{type: action.type, activeMenu: action.payload},
            };
        case Config.REDUX_TYPES.SET_THEME_PROPS:
            return {...state, ...action};
        case Config.REDUX_TYPES.CONTENT_CHANGED:
            return {
                ...state,
                ...{type: action.type, contentChanged: action.payload},
            };
        case Config.REDUX_TYPES.SET_USER_HOTELS:
            return {
                ...state,
                ...{type: action.type, userHotels: action.payload},
            };
        case Config.REDUX_TYPES.SET_HOTEL_INFO:
            return {
                ...state,
                ...{type: action.type, hotelInfo: action.payload},
            };
        case Config.REDUX_TYPES.SET_WYNDHAM_REVIEW_STARTED:
            return {
                ...state,
                type: action.type,
                wyndhamReviewStarted: action.payload === true,
            };
        case Config.REDUX_TYPES.SET_WYNDHAM_REVIEW_STATUS:
            return {
                ...state,
                type: action.type,
                wyndhamReviewStatus: action.payload || {...emptyWyndhamReviewStatus},
            };
        case Config.REDUX_TYPES.SET_WYNDHAM_REVIEW_NOTICE:
            return {
                ...state,
                type: action.type,
                wyndhamReviewNoticeVisible: action.payload && action.payload.visible === true,
                wyndhamReviewNoticeDismissedFor: action.payload && Object.prototype.hasOwnProperty.call(action.payload, 'dismissedFor')
                    ? action.payload.dismissedFor
                    : state.wyndhamReviewNoticeDismissedFor,
            };
        case Config.REDUX_TYPES.WYNDHAM_FIELD_CHANGED: {
            const entry = action.payload;
            if (!entry || !entry.fieldId) {
                return state;
            }
            const existingIndex = (state.wyndhamChangedFields || []).findIndex(
                (field) => field.fieldId === entry.fieldId,
            );

            // Explicit remove when value reverted to session start
            if (entry.remove === true) {
                if (existingIndex < 0) {
                    return state;
                }
                return {
                    ...state,
                    type: action.type,
                    wyndhamChangedFields: state.wyndhamChangedFields.filter(
                        (_, index) => index !== existingIndex,
                    ),
                };
            }

            let wyndhamChangedFields;
            if (existingIndex >= 0) {
                wyndhamChangedFields = state.wyndhamChangedFields.map((field, index) =>
                    index === existingIndex
                        ? {...field, newValue: entry.newValue}
                        : field,
                );
            } else {
                wyndhamChangedFields = [...(state.wyndhamChangedFields || []), {
                    fieldId: entry.fieldId,
                    label: entry.label,
                    sectionId: entry.sectionId,
                    oldValue: entry.oldValue,
                    newValue: entry.newValue,
                }];
            }
            return {
                ...state,
                type: action.type,
                wyndhamChangedFields,
            };
        }
        default:
            return state;
    }
};

export default Reducer;
